"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warningExtra = exports.warning = void 0;
var warning = {
  50: '#FDF8E6',
  100: '#FBEDC1',
  200: '#F9E198',
  300: '#F6D46E',
  400: '#F4CB4F',
  500: '#F2C230',
  600: '#F0BC2B',
  700: '#EEB424',
  800: '#ECAC1E',
  900: '#E89F13'
};
exports.warning = warning;
var warningExtra = {
  light: '#FDF8E6'
};
exports.warningExtra = warningExtra;
//# sourceMappingURL=warning.js.map